import { render, staticRenderFns } from "./SearchCard.vue?vue&type=template&id=d20ed6d4&scoped=true&"
import script from "./SearchCard.vue?vue&type=script&lang=js&"
export * from "./SearchCard.vue?vue&type=script&lang=js&"
import style0 from "./SearchCard.vue?vue&type=style&index=0&id=d20ed6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20ed6d4",
  null
  
)

export default component.exports